import RequestsDistributeDetailEdit from './RequestsDistributeDetailEdit';
import { MOVE } from 'constants/constants';

const RequestsMoveDetailEdit = () => {
  return <RequestsDistributeDetailEdit action={MOVE} />;
};

export default RequestsMoveDetailEdit;
